
const defaultState = {
	template: 'default',
	modal: true,
	lang: '',
	product: false
};


export const view = (state = defaultState, { type, data }) => {
	switch (type) {
		case 'template':
			return { ...state, template: data };
		case 'hide_modal':
			return { ...state, modal: !state.modal };
		case 'LANG':
			return { ...state, lang: data };
		case 'VIEW':
			return { ...state, ...data };
		default:
			return state;
	}
}


export const switchTemplate = (data) => {
	return dispatch => dispatch({
		type: 'template', data
	})
};

export const changeView = (data) => {
	return dispatch => dispatch({
		type: 'VIEW', data
	})
};